<template>
  <nav data-testid="breadcrumb-links" aria-label="Breadcrumb" class="mb-4">
    <ol class="flex items-center gap-2">
      <slot />
    </ol>
  </nav>
</template>
